import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { login } from '../Auth.actions'
import LoginFormComponent from './LoginForm'

const formName = 'loginForm'

const stateToProps = () => ({})

const dispatchToProps = {
  login,
}

export default connect(
  stateToProps,
  dispatchToProps
)(reduxForm({ form: formName })(LoginFormComponent))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/LoginForm/LoginForm.container.js